<template>
    <div class="width-text-input">
        <b-table hover ref="ReportCodTable" :items="items" :fields="fields" 
        :per-page="search.perPage" :current-page="search.page" responsive show-empty>
            <template slot="index" slot-scope="row">
                {{row.index+1}}
            </template>
            <template slot="bank_account_name" slot-scope="row">
                {{row.item.bank_account_name}}
            </template>
            <template slot="bank_account_id" slot-scope="row">
                <span>
                    เลขที่บัญชี: {{row.item.bank_account_id}}
                </span><br/>
                <span>
                    ธนาคาร: {{ formatBank(row.item.bank_account_bank) }}
                </span>
            </template>
            <template slot="cod_amount" slot-scope="row">
                {{ formatNumber(row.item.cod_amount) }}
            </template>
            <template slot="cod_fee" slot-scope="row">
                {{ formatNumber(row.item.cod_fee) }}
            </template>
            <template slot="cod_vat" slot-scope="row">
                {{ formatNumber(row.item.cod_vat) }}
            </template>
            <template slot="return_cod" slot-scope="row">
                {{ formatNumber(row.item.cod_amount - row.item.cod_vat) }}
            </template>
            <template slot="state" slot-scope="row">
                <span :class="row.item.state === 'transferred' ? 'text-green' : 'text-danger'">
                    {{row.item.state === 'transferred' ? 'โอนเงินแล้ว' : 'ยังไม่ได้โอนเงิน'}}
                </span>
            </template>
            <template slot="created_at" slot-scope="row">
                {{ formatDate(row.item.created_at) }}
            </template>
            <template slot="actions" slot-scope="row">
                <button class="btn px-3 btn-sm btn-danger" @click="detailOrder(row.item)">ดูรายละเอียด COD</button>
            </template>
        </b-table>
        <div class="d-flex justify-content-center mt-3">
            <b-pagination :value="search.page" @input="changePage" :total-rows="totalItems" :current-page="search.page" :per-page="search.perPage" align="right">
            </b-pagination>
        </div>
    </div>
</template>
    
<script>
import formatBankCode from '@/plugins/formatBank.js'
import moment from "moment";
export default {
    props: {
        items: Array,
        selected: Array,
        fields: Array,
        search: Object,
        totalItems: Number,
        dateStart: String,
        dateEnd: String,
    },
    data() {
        return {
            userLogin: '',
            checkSelect: false
        }
    },
    mounted() {
        this.userLogin = JSON.parse(localStorage.getItem("user"))
    },
    methods: {
        numFormat (value) {
            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
        },
        detailOrder(item) {
            this.$router.push({ path: `/reportcod/${item.mem_id}`, query: { date_start: this.dateStart, date_end: this.dateEnd }})
        },
        formatNumber (num) {
            return `${this.$options.filters.numFormat(num,'0,0.00')}`;
        },
        changePage(i) {
            if (this.search.page == i) return;
            this.search.page = i
        },
        formatBank(target) {
            let result = formatBankCode.find((key) => {
                return key.code === target
            })
            return result.name
        },
        formatDate(date) {
            return moment(new Date(date)).format("DD-MM-YYYY");
        }
    },
}
</script>
    